import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Port, CreatePortDto, UpdatePortDto } from '../../models/forwarding/port.model';

export interface PortVendorSummary {
  vendorId: number;
  vendorName: string;
  vendorCode: string | null;
  contactEmail: string | null;
}

@Injectable({ providedIn: 'root' })
export class PortService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/forwarding/ports`;

  getAll(): Observable<Port[]> {
    return this.http.get<Port[]>(this.apiUrl);
  }

  getById(id: number): Observable<Port> {
    return this.http.get<Port>(`${this.apiUrl}/${id}`);
  }

  search(term: string): Observable<Port[]> {
    return this.http.get<Port[]>(`${this.apiUrl}/search?term=${encodeURIComponent(term)}`);
  }

  create(dto: CreatePortDto): Observable<Port> {
    return this.http.post<Port>(this.apiUrl, dto);
  }

  update(id: number, dto: UpdatePortDto): Observable<Port> {
    return this.http.put<Port>(`${this.apiUrl}/${id}`, dto);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  getAgents(portId: number): Observable<PortVendorSummary[]> {
    return this.http.get<PortVendorSummary[]>(`${this.apiUrl}/${portId}/agents`);
  }

  getCoLoaders(portId: number): Observable<PortVendorSummary[]> {
    return this.http.get<PortVendorSummary[]>(`${this.apiUrl}/${portId}/co-loaders`);
  }

  assignVendor(portId: number, vendorId: number): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/${portId}/vendor-port-services`, { vendorId });
  }

  // ---- Legacy API shim — used by add-port-charge-modal ----
  /** @deprecated Use getAll() */
  getPorts(): Observable<Port[]> {
    return this.getAll();
  }
}
